!(function (o) {
  "use strict";
  o(window).on("scroll", function () {
    70 < o(window).scrollTop()
      ? o(".site-navigation,.trans-navigation").addClass("header-white")
      : o(".site-navigation,.trans-navigation").removeClass("header-white");
  }),
    o(window).width() < 992 &&
      o(".navbar-collapse .dropdown-toggle").on("click", function () {
        o(this).siblings(".dropdown-menu").animate({ height: "toggle" }, 300);
      }),
    o(window).width() < 992 &&
      o(".navbar-toggler").on("click", function () {
        // Close all open dropdowns when toggler is clicked
        o(".navbar-collapse .dropdown-menu").stop(true, true).slideUp(300);
      }),
    o(window).on("scroll", function () {
      var n;
      0 !== o(".counter").length &&
        (n = o(".counter").offset().top - window.innerHeight),
        o(window).scrollTop() > n &&
          o(".counter").each(function () {
            var n = o(this),
              t = n.attr("data-count");
            o({ countNum: n.text() }).animate(
              { countNum: t },
              {
                duration: 500,
                easing: "swing",
                step: function () {
                  n.text(Math.floor(this.countNum));
                },
                complete: function () {
                  n.text(this.countNum);
                },
              }
            );
          });
    }),
    o("a.nav-link").click(function (n) {
      var t;
      // Skip dropdown toggles - let Bootstrap handle them
      if (o(this).hasClass("dropdown-toggle")) {
        return true;
      }
      // Skip links with empty hash
      if (!this.hash || this.hash === "#") {
        return true;
      }
      location.pathname.replace(/^\//, "") !==
        this.pathname.replace(/^\//, "") ||
        location.hostname !== this.hostname ||
        ((t = (t = o(this.hash)).length
          ? t
          : o("[name=" + this.hash.slice(1) + "]")).length &&
          (n.preventDefault(),
          o("html, body").animate(
            { scrollTop: t.offset().top },
            1e3,
            function () {
              var n = o(t);
              if ((n.focus(), n.is(":focus"))) return !1;
              n.attr("tabindex", "-1"), n.focus();
            }
          )));
    }),
    o(".navbar-collapse .navbar-nav a").on("click", function () {
      // Don't close navbar for dropdown toggles
      if (!o(this).hasClass("dropdown-toggle")) {
        o(".navbar-toggler:visible").click();
      }
    }),
    // Close navbar when clicking outside
    o(document).on("click", function (e) {
      var navbar = o(".navbar-collapse");
      var toggler = o(".navbar-toggler");
      // If navbar is visible and click is outside navbar
      if (navbar.hasClass("show") && !navbar.has(e.target).length && !toggler.has(e.target).length) {
        toggler.click();
      }
    });
})(jQuery);

document.addEventListener('DOMContentLoaded', function() {
  var user = 'info';
  var domain = 'mrshinezdetailing.com.au';
  var email = user + '@' + domain;
  var emailLinks = document.querySelectorAll('.obfuscated-email');
  emailLinks.forEach(function(emailLink) {
    emailLink.textContent = email;
    emailLink.href = 'mailto:' + email;
  });
});